import React, { useEffect, useState } from "react"
import styled, { css } from "styled-components"
import { useInView } from "react-intersection-observer"
import { isIE, isSafari } from "react-device-detect"

import * as anim from "./Animation"

const IoAnimator = ({ threshold, playOnce, ...rest }) => {
  // check for Safari because Safari version less than 12 doesn't support intersection observer
  if (!isIE && !isSafari) {
    var [ref, inView] = useInView({
      threshold: threshold
    })
  }

  const [shouldAnimate, setShouldAnimate] = useState(false)

  useEffect(() => {
    if (isIE || isSafari) {
      setShouldAnimate(true)
    }
  }, [])

  useEffect(() => {
    if (!!playOnce && !!inView) {
      setShouldAnimate(true)
    } else if (!playOnce && !isIE) {
      setShouldAnimate(inView)
    }
  }, [inView])

  return <Container {...rest} ref={ref} inView={shouldAnimate} />
}

export default IoAnimator

IoAnimator.defaultProps = {
  threshold: 0.25,
  animation: "fadeIn",
  animationTime: 0.6,
  ease: "ease-in-out",
  playOnce: true
}

const Container = styled.div`
  will-change: transform, opacity;
  opacity: 0;
  ${props =>
    !!props.inView &&
    css`
      animation: ${anim[props.animation]} ${props.animationTime + "s"} 0s
        ${props.ease} forwards;
    `}
  ${props =>
    css`
      transition: opacity ${props.animationTime / 2 + "s"} ${props.ease};
    `}
`
